import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AlertService } from '../_services/alert.service';
import { environment } from '../../environments/environment';

import { DivisaoEmpresa } from '../_models';

@Injectable({
    providedIn: 'root'
})

export class DivisaoEmpresaService {

    getDivisoesByEmpresa(codEmp: string, codFil: string): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/DivisaoEmpresa?codigoEmpresa=${codEmp}&codFil=${codFil}` ;
        return this.http.get<DivisaoEmpresa[]>(apiURL);
    }

    constructor(private http: HttpClient,
        private alertService: AlertService) { }


    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            console.error(error); // log to console instead
            console.log(`${operation} failed: ${error.message}`);

            this.alertService.error(`Ocorreu um erro ao buscar as divisões. Detalhes: \n ${operation} failed: ${error.message}`);
            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

}
